const DEFAULT_LOCALE = 'el';
const SUPPORTED_LOCALES = ['en-US', 'el', 'es'];

const getSupportedLocale = locale => {
  const language =
    typeof locale === 'string'
      ? locale
          .trim()
          .toLowerCase()
          .split('-')[0]
      : '';
  return language === 'en' ? 'en-US' : SUPPORTED_LOCALES.includes(language) ? language : null;
};

const normalizeLocale = locale => getSupportedLocale(locale) || DEFAULT_LOCALE;
const getBrowserLocale = (languages = []) =>
  languages.map(getSupportedLocale).find(Boolean) || 'en-US';

const LANGUAGE_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

const getLanguageCode = locale => normalizeLocale(locale).split('-')[0];

// Picks the matching segment from a "English|Greek|Spanish" pipe-separated value.
// Falls back to English when the requested language segment is missing.
const getLocalizedPipeValue = (value, locale) => {
  if (typeof value !== 'string' || !value.includes('|')) return value;
  const segments = value.split('|');
  const code = getLanguageCode(locale);
  if (code === 'el') return segments[1] || segments[0];
  if (code === 'es') return segments[2] || segments[0];
  return segments[0];
};

module.exports = {
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES,
  LANGUAGE_COOKIE_MAX_AGE,
  getSupportedLocale,
  getBrowserLocale,
  normalizeLocale,
  getLanguageCode,
  getLocalizedPipeValue,
};
